var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleAppDownloadHint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    width: 20,
    height: 20,
    transform: "translate(0 0)",
    fill: "#212020",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    transform: "translate(1.563 1.53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    d: "M9.2.86A8.357,8.357,0,1,0,16.23,4.71l-.5.587a7.655,7.655,0,1,1-1.4-1.712l.475-.561A8.313,8.313,0,0,0,9.2.86Zm6.616,2.088L8.811,11.22,5.86,8.468,5.365,9l3.507,3.271,7.5-8.853Z",
    transform: "translate(-0.86 -0.86)",
    fill: "#212020"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleAppDownloadHint);
export default __webpack_public_path__ + "static/media/check-circle-app-download-hint.c1c28565530e6537beb846982ee09082.svg";
export { ForwardRef as ReactComponent };